import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import { Dashboard } from "./pages/dashboard/Dashboard"
import { Login } from "./pages/login/Login"
import "bootstrap/dist/css/bootstrap.min.css"
import { ForgotPassword } from "./pages/login/ForgotPassword"
import ReactGA from "react-ga"
import { ResetPassword } from "./pages/login/ResetPassword"
import { useEffect } from "react"
import p from "../package.json"
ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID)
function App() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
    document.title = `${process.env.REACT_APP_APP_NAME} ${p.version}`
  }, [])
  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token/:email" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </Router>
    </>
  )
}

export default App
